module.exports = __webpack_public_path__ + "img/9_22.e48bb576.png";